const ACTIONS = {
    SELECT_NEXT: 'CAROUSEL/SELECT_NEXT',
    SELECT_PREV: 'CAROUSEL/SELECT_PREV',
    CHANGE_IMAGE_INDEX: 'CAROUSEL/CHANGE_IMAGE_INDEX',
    SET_VERTICAL_GALLERY_OPEN_STATE: 'CAROUSEL/SET_VERTICAL_GALLERY_OPEN_STATE'
};

const ACTION_CREATORS = {
    changeImageIndex(newIndex) {
        return {
            type: ACTIONS.CHANGE_IMAGE_INDEX,
            payload: {
                newIndex
            }
        };
    },

    selectNext(currentIndex, numImages) {
        return {
            type: ACTIONS.SELECT_NEXT,
            payload: {
                currentIndex,
                numImages
            }
        };
    },

    selectPrev(currentIndex, numImages) {
        return {
            type: ACTIONS.SELECT_PREV,
            payload: {
                currentIndex,
                numImages
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
